import React from 'react';
import { useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import Box from 'ui-box';
import { Button, FormField, InputGroup, majorScale } from '../../../npaper';
import { IUser, useStores } from '../../../stores';
import { AuthTitle } from '../AuthLayout';

type ProfileValues = {
  first_name: string;
  last_name: string;
  phone: string;
};

const ProfileStep = ({
  onUpdate,
  user,
}: {
  onUpdate: () => void;
  user: IUser;
}) => {
  const { authStore } = useStores();
  const intl = useIntl();
  const { register, handleSubmit, formState } = useForm<ProfileValues>({
    defaultValues: {
      first_name: user.first_name || '',
      last_name: user.last_name || '',
      phone: user.phone || '',
    },
  });

  // TODO: Handle errors

  const onSubmit = async (values: ProfileValues) => {
    await authStore.updateMe(values);
    onUpdate();
  };

  return (
    <Box>
      <AuthTitle
        title={intl.formatMessage({
          defaultMessage: 'Tell us a bit about yourself',
        })}
        sub={intl.formatMessage(
          {
            defaultMessage: 'Step {step} of {maxSteps}',
          },
          {
            step: 1,
            maxSteps: 3,
          }
        )}
        description={intl.formatMessage({
          defaultMessage: 'Fill out your name and your contact details',
        })}
      />

      <FormField
        label={intl.formatMessage({
          defaultMessage: 'Name',
        })}
        marginBottom={majorScale(2)}
        large
      >
        <InputGroup
          placeholder={intl.formatMessage({
            defaultMessage: 'First name',
          })}
          name="first_name"
          ref={register({
            required: intl.formatMessage({
              defaultMessage: 'We need to know your first name',
              description: 'Validation: required',
            }),
          })}
        />
        <InputGroup
          placeholder={intl.formatMessage({
            defaultMessage: 'Last name',
          })}
          name="last_name"
          ref={register}
        />
      </FormField>

      <FormField
        label={intl.formatMessage({
          defaultMessage: 'Phone',
        })}
        marginBottom={majorScale(2)}
        large
      >
        <InputGroup
          placeholder={intl.formatMessage({
            defaultMessage: 'Phone',
          })}
          name="phone"
          ref={register}
        />
      </FormField>

      <Button
        primary
        width="100%"
        onClick={handleSubmit(onSubmit)}
        isLoading={formState.isSubmitting}
      >
        <FormattedMessage id="defaults.continue" defaultMessage="Continue" />
      </Button>
    </Box>
  );
};

export default ProfileStep;
